import { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentUser } from '../../../store';
import './TutorialModal.css';
import SupervisorTutorial from './supervisor/SupervisorTutorial';
import { SusyCarouselModal } from '../../shared/modals/susyCarouselModal/SusyCarouselModal';
interface Props {
    initialOpen: boolean;
    getCurrentUser: () => void;
}

interface State {
    show: boolean;
}

class TutorialModal extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            show: this.props.initialOpen,
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps !== this.props) {
            this.setState({ show: this.props.initialOpen });
        }
    }

    openModal = () => {
        this.setState({ show: true });
    };

    closeModal = async () => {
        await this.props.getCurrentUser();
        this.setState({ show: false });
    };

    render() {
        const supervisorTutorialModalBody = (
            <SupervisorTutorial closeModal={this.closeModal} />
        );
        return (
            <SusyCarouselModal
                show={this.state.show}
                size='lg'
                ariaLabelledBy='contained-modal-title-vcenter'
                centered
                id={'tutorial-carousel'}
                dataTestId={'tutorial-user-carousel'}
                modalBody={supervisorTutorialModalBody}
            ></SusyCarouselModal>
        );
    }
}

export default connect(null, { getCurrentUser })(TutorialModal);
